<nz-badge [nzCount]="unread">
    <button nz-button nzShape="circle" nz-popover nzPopoverTrigger="click" [nzPopoverContent]="popoverContentTpl"
        nzPopoverPlacement="bottomRight" (nzPopoverVisibleChange)="notificationFeedVisibleChange($event)"
        [(nzPopoverVisible)]="notificationVisible">
        <span nz-icon nzType="bell" nzTheme="outline"></span>
    </button>
</nz-badge>
<ng-template #popoverContentTpl>
    <div nz-row class="notification-popover">
        <div nz-col nzFlex="200px" class="notification-groups">
            <ul nz-menu nzMode="inline">
                <li nz-menu-item *ngFor="let group of notificationGroups" [nzSelected]="group === selectedGroup"
                    (click)="selectGroup(group)">
                    <i nz-icon [nzType]="group.icon" nzTheme="outline"></i>
                    <span>{{ group.title }}</span>
                    <nz-badge class="group-unread" nzStandalone nzSize="small" [nzCount]="unreadByGroup[group.key]"></nz-badge>
                </li>
            </ul>
        </div>
        <div nz-col nzFlex="auto">
            <nz-list class="notifcation-feed-popover pl-2 pr-2" [nzHeader]="headerTpl" [nzLoading]="loadingNotifications">
                <div class="notification-items">
                    <nz-list-item class="pl-2 pr-2" *ngFor="let notification of notifications" [ngSwitch]="notification.type"
                        (click)="selectNotification(notification)">
                        <nz-list-item-meta [nzAvatar]="avatarTpl" [nzDescription]="descriptionTpl">
                            <nz-list-item-meta-title>
                                <a nz-tooltip [nzTooltipTitle]="(notification.createdAt | date:'medium')">{{
                                    notification.createdAt | dateAgo: '' }}</a>
                            </nz-list-item-meta-title>
                            <ng-template #avatarTpl>
                                <nz-avatar nzIcon="user" [nzSrc]="notification.author.profileImageUrl">
                                </nz-avatar>
                            </ng-template>
                        </nz-list-item-meta>
                        <ul nz-list-item-actions>
                            <nz-list-item-action>
                                <button nz-button *ngIf="!notification.read" nzType="text" nzShape="circle" [nzSize]="'small'"
                                    (click)="markAsRead(notification.id)" nz-tooltip nzTooltipTitle="Mark as read"
                                    nzTooltipPlacement="bottom">
                                    <i nz-icon nzType="check-circle">
                                    </i>
                                </button>
                            </nz-list-item-action>
                        </ul>
                        <ng-template #descriptionTpl>
                            <span nz-typography>
                                <strong>
                                    <a nz-tooltip *ngIf="notification.author" [nzTooltipTitle]="notification.author.email">
                                        {{ notification.author.name }}
                                    </a>
                                    <a nz-tooltip *ngIf="notification.author.id == 0">
                                        System
                                    </a>
                                </strong>
                                <span *ngSwitchCase="'ticket_created'">
                                    created
                                </span>
                                <span *ngSwitchCase="'ticket_updated'">
                                    updated
                                </span>
                                <span *ngSwitchCase="'assign'">
                                    assigned you to
                                </span>
                                <span *ngSwitchCase="'mention'">
                                    mentioned you in
                                </span>
                                <span *ngSwitchCase="'comment'">
                                    commented on
                                </span>
                                <span *ngSwitchCase="'design_task_updated'">
                                    updated <strong><a>Task {{ notification.designTaskId | zeroPadding}}</a></strong> in
                                </span>
                                <span *ngSwitchCase="'design_task_assign'">
                                    assigned you to <strong><a>Task {{ notification.designTaskId | zeroPadding}}</a></strong> in
                                </span>
                                <span *ngSwitchCase="'design_task_unassign'">
                                    unassigned you from <strong><a>Task {{ notification.designTaskId |zeroPadding}}</a></strong> in
                                </span>
                                <span *ngSwitchCase="'fab_task_updated'">
                                    updated a fabrication task in
                                </span>
                                <span *ngSwitchCase="'fab_task_assign'">
                                    assigned you to a fabrication task in
                                </span>
                                <span *ngSwitchCase="'fab_task_unassign'">
                                    unassigned you from a fabrication task in
                                </span>
                                <strong><a>Case {{ notification.ticketId | zeroPadding}}</a></strong>
                            </span>
                        </ng-template>
                    </nz-list-item>
                    <div nz-list-load-more class="loadmore pt-2 pb-2">
                        <button nz-button *ngIf="!loadingMore && havingMore == true" (click)="loadMore()">Load More</button>
                    </div>
                    <nz-list-empty *ngIf="!notifications || notifications.length === 0"></nz-list-empty>
                </div>
            </nz-list>
        </div>
    </div>
    <ng-template #headerTpl>
        <div nz-row>
            <div nz-col nzSpan="16">
                <div nz-row>
                    <span class="title" nz-typography><strong>Notifications</strong></span><br />
                </div>
            </div>
            <div nz-col nzSpan="8">
                <div nz-row nzJustify="end">
                    <div nz-col>
                        <a (click)="markAllAsRead()">Mark all as read</a>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</ng-template>
